import ChannelActionMenu from './ChannelActionMenu';

export default ChannelActionMenu;
